import React from 'react'
import { Link } from 'gatsby'
import { Location } from '@reach/router'

// const navLinkClass =
//   'dib v-mid link dim inherit f7 f6-ns fw5 br3 ph2 ph3-l pv2 pointer'

class Header extends React.Component {
  setHeader = location => {
    switch (location.pathname) {
      case '/':
        return 'bg-transparent white'
      case '/brand':
        return 'bg-transparent white'
      default:
        return 'bg-white brand-navy'
    }
  }

  render() {
    return (
      <Location>
        {({ location }) => {
          return (
            <nav
              className={`nav fixed left-0 top-0 dib w-100 z-2 lh-copy ${this.setHeader(
                location
              )}`}
            >
              <div className="center mw9 ph3 ph5-ns pv3 pv3-ns">
                <div className="flex items-center justify-between">
                  <div className="dib relative v-mid tl">
                    <Link
                      className="dib v-mid link dim f6 b ttu inherit"
                      to="/"
                    >
                      <img
                        className="dib relative logo v-mid"
                        src={
                          location.pathname === '/' ||
                          location.pathname === '/brand'
                            ? '/logo-canada-white.svg'
                            : '/logo-canada.svg'
                        }
                        alt="Paytm for business"
                      />
                    </Link>
                  </div>
                  {/* <div className="dn dib-ns relative v-mid">
                    <Link to="/offerings" className={navLinkClass}>
                      Offerings
                    </Link>
                    <Link to="/company" className={navLinkClass}>
                      Company
                    </Link>
                    <Link to="/support" className={navLinkClass}>
                      Support
                    </Link>
                  </div>
                  <div className="dib relative v-mid tr f7 f6-ns">
                    <Link to="/login" className={navLinkClass}>
                      Login
                    </Link>
                    <Link
                      to="/signup"
                      className="dib v-mid link dim white bg-brand-blue ph3 pv2 br-pill b"
                    >
                      Sign Up
                    </Link>
                  </div> */}
                </div>
              </div>
            </nav>
          )
        }}
      </Location>
    )
  }
}

export default Header
